<div class="header">
  <div class="navBar">
    <div>
      <img src="./assets/images/AssessorLogo_Transparent.png" alt="Douglas Count, Co. Assessor's Office" width="300px"/>
    </div>
    <div class="subtitle"><a routerLink="/">Advanced Search and Reports</a></div>
    <div class="rightStack">
      <div>
        <a href="{{_environment.assessorUrl}}" target="_blank">
          <div class="back-to-site">
            ASSESSOR HOME
          </div>
        </a>
      </div>
      <div class="navBar">
        <div class="navBar" style="margin-bottom: 5px"></div>
        <div class="navBar">
          <div class="menuTrigger">
            <div class="btn menuTrigger" (click)="openReferenceGuide()">
              Report Guide <i class="fa fa-question-circle-o fa-2x"></i>
            </div>
          </div>
          <div class="menuTrigger">
            <div class="btn menuTrigger" (click)="burgerTime()">
              Actions & Links <i class="fa fa-bars fa-2x"></i>
            </div>
            <div *ngIf="showBurger==true" class="menuWrapper" (click)="burgerTime()">
              <div id="actionsLinksMenu" class="menu" click="void(0)">
                <span><a href="http://apps.douglas.co.us/assessor/web/#/" target="_blank">New Property Search</a></span>
                <span class="hr"></span>
                <span><a href="https://apps.douglas.co.us/apps/assessor/comps/compsBySubdivision.do" target="_blank">Study Period Sales Search</a></span>
                <span><a href="https://www.douglas.co.us/assessor/appeals/" target="_blank">Appeals</a></span>
                <span><a href="https://www.douglas.co.us/assessor/residential-property/change-mailing-address/" target="_blank">Update Mailing Address</a></span>
                <span class="hr"></span>
                <span><a href="https://www.douglas.co.us/assessor/residential-exemptions/" target="_blank">Exemptions for Seniors &amp; Veterans</a></span>
                <span><a href="https://www.douglas.co.us/assessor/business-personal-property/" target="_blank">Business Personal Property</a></span>
                <span><a href="https://www.douglas.co.us/assessor/forms/" target="_blank">Assessor Forms</a></span>
                <span><a href="https://www.douglas.co.us/assessor/real-estate-data-center/"
                        target="_blank">Assessor Data Tools</a></span>
                <span><a href="http://www.douglas.co.us/assessor/" target="_blank">Assessor Home</a></span>
                <span><a href="http://community.spatialest.com/co/douglas/" target="_blank">Go to DougCo Connect</a></span>
                <span class="hr"></span>
                <span><a href="mailto:{{_environment.assessorEmail}}?subject=Suggest%20an%20Improvement">Suggest an Improvement</a></span>
                <span><a style="cursor: pointer;" (click)="showDialog()">About</a></span>
              </div>
            </div>
          </div>
        </div>
      </div>    
    </div>
  </div>
</div>
<span class="navBar bottomBorder"></span>
<p-dialog header="About" [(visible)]="display" [width]="500" [modal]=true [draggable]=false [resizable]=false>
  <div class="build">
    <span>Config/Build: {{_environment.envName}}</span>
  </div>
  <div class="build">  
    <span>Revision:</span> 
    <span>{{_build.revision}}</span>
  </div>
  <div class="build">
    <span>Branch:</span>
    <span>{{_build.branch}}</span>
  </div>
</p-dialog>
<router-outlet></router-outlet>

<!--<div id="watermark" *ngIf="_environment.production===false">
  <div class="build">Config/Build: {{_environment.envName}}</div>
  <div class="build">
    <span>Revision:</span>
    <span>{{_build.revision}}</span>
  </div>
  <div class="build">
    <span>Branch:</span>
    <span>{{_build.branch}}</span>
  </div>
</div>-->




